<template>
  <div class="c-ZnlSlider">
    <div class="c-ZnlSlider-left" v-show="!store.state.layout.hideleft">
      <el-menu
        :default-active="store.state.route.name"
        background-color="#273142"
        text-color="#fff"
        :router="false"
        ref="elmenu"
      >
        <el-menu-item
          v-for="item in routers"
          :key="item.name"
          :index="item.path"
          :disabled="item.meta ? item.meta.disabled : false"
          @click="() => slideItemClickHandler(item)"
          v-if="item.meta ? !item.meta.hide : false"
        >
          <i :class="['iconfont', item.icon ? item.icon : '']"></i>
          <span slot="title" class="menutitle">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="c-ZnlSlider-right" :style="sliderRightStyle">
      <!-- <keep-alive> -->
      <component
        :is="routeName"
        v-bind="$attrs"
        :company-click-handler="companyClickHandler"
        :isZnl="isZnl"
      ></component>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>
<script>
import TradingStore from '../store';
// import Home from './Home/main';
import ReceivedInquiry from './ReceivedInquiry/main.vue';
import SalesOrder from './SalesOrder/main.vue';
import Statement from './Statement/main.vue';
import OutgoingInquiry from './OutgoingInquiry/main.vue';
import InventoryPricing from './InventoryPricing/main.vue';
import PricingStrategy from './PricingStrategy/main.vue';
// import SalesChannels from './SalesChannels/main.vue';
// import ChannelAnalysis from './ChannelAnalysis/main.vue';
import PurchaseOrder from './PurchaseOrder/main.vue';
import MyBom from './MyBom/main.vue';
import Information from './Information/main.vue';
import PurchaseOrderList from './PurchaseOrderList/main.vue';
import PurchaseOrderListDetails from './PurchaseOrderListDetails/main.vue';
export default {
  name: 'TradingSlider',
  props: {
    companyClickHandler: Function,
    routers: {
      type: Array,
      default() {
        return [];
      }
    },
    isZnl: Boolean
  },

  components: {
    // Home,
    ReceivedInquiry,
    SalesOrder,
    Statement,
    OutgoingInquiry,
    InventoryPricing,
    PricingStrategy,
    // SalesChannels,
    // ChannelAnalysis,
    PurchaseOrder,
    MyBom,
    Information,
    PurchaseOrderList,
    PurchaseOrderListDetails
  },

  data() {
    return {
      store: TradingStore,
      componentId: ''
    };
  },

  computed: {
    sliderRightStyle() {
      const style = { left: '0', top: '0', padding: '10px' };
      style.left = !this.store.state.layout.hideleft ? '160px' : '0';
      return style;
    },
    routeName() {
      return this.store.state.route.name;
    }
  },

  methods: {
    slideItemClickHandler(route) {
      this.store.commit('setRoute', { name: route.name });
      this.$emit('route-change', route.name);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/style/var.scss';
.c-ZnlSlider {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  .c-ZnlSlider-left {
    height: 100%;
    width: $--left-sidebar-width;
    @include position;
    overflow-y: auto;
  }
  .c-ZnlSlider-right {
    // height: 100%;
    // padding: 10px;
    box-sizing: border-box;
    @include position($left: $--left-sidebar-width);
    background-color: $--color-bg;
    right: 0;
    bottom: 0;
    & > div {
      height: 100%;
      overflow-y: auto;
      background-color: $--color-bg-model;
      padding: 10px 20px;
      box-sizing: border-box;
      box-shadow: 0 2px 2px 0px rgba(0, 0, 0, 0.16);
    }
  }
  .el-menu,
        .el-submenu__title,
        .el-menu-item-group__title,
        // .el-menu-item,
        .el-menu-item-group {
    width: $--left-sidebar-width;
    box-sizing: border-box;
  }
  .el-menu {
    height: 100%;
  }
  .el-menu-item {
    font-size: $--font-size-base;
    height: $--left-sidebar-itemheight;
    line-height: $--left-sidebar-itemheight;
    color: $--fontcolor-light-3 !important;
    padding-left: 10px !important;
    &.is-active {
      background-color: $--color-subsidiary !important;
      color: $--fontcolor-light-4 !important;
    }
    &.is-disabled {
      font-size: $--font-size-base;
      background-color: $--color-primary-light-1 !important;
      color: $--fontcolor-light-3 !important;
      cursor: default;
      height: $--left-sidebar-titleheight;
      line-height: $--left-sidebar-titleheight;
      opacity: 1;
      margin-top: 10px;
      &:nth-child(2) {
        margin-top: 0;
      }
    }
    .menutitle {
      margin-left: 5px;
    }
  }
}
</style>
